/**
 *
 * Mobile.mixin
 *
 */

import { mapActions, mapState, mapGetters } from 'vuex';

import $ from 'jquery';

import { DEFAULT_DATA_URL, MOBILE_TIMER } from '@/constants/index';

export const MobileMixin = {
  name: 'MobileMixin',

  data: () => {
    return {
      region: '+86',
      regionCountry: '中国',
      shortMobile: '',
      captchaCode: '',
      mobileCode: '',
      isRegionShown: false,
      isMobileExist: '',
      captcha: DEFAULT_DATA_URL,
      mobileCodeCounter: MOBILE_TIMER,
      itvlMobileCode: null,
      errMessageMobileCode: '',
      errMessageMobile: '',
      params: null,
    };
  },

  computed: {
    ...mapState({
      ms_isWechatBrowser: (state) => state.browserInfo.isWechatBrowser,
    }),

    ...mapState('Mixins/Mobile', {
      ms_regionNo: 'regionNo',
      ms_isMobileRequest: 'isMobileRequest',
      ms_isMobileCheckExistRequest: 'isMobileCheckExistRequest',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_isMobileUpdated() {
      return Boolean(this.mg_userInfo.mobile);
    },

    c_mobile() {
      return this.region + this.shortMobile;
    },

    c_isShortMobileWrongFmt() {
      if ('' !== this.shortMobile && this.shortMobile.match(/^\d+$/) === null) {
        return true;
      }
      return false;
    },

    c_isMobileReady() {
      if ('' === this.shortMobile || this.c_isShortMobileWrongFmt) {
        return false;
      }
      return true;
    },

    c_isMobileCodeCounterOk() {
      return MOBILE_TIMER === this.mobileCodeCounter;
    },

    c_isMobileReadyAndMobileCodeCounterOk() {
      return this.c_isMobileReady && this.c_isMobileCodeCounterOk;
    },

    c_isMobileReadyAndMobileCodeCounterOkAndMobileExist() {
      return this.c_isMobileReadyAndMobileCodeCounterOk && true === this.isMobileExist;
    },

    c_isMobileReadyAndMobileCodeCounterOkAndNotMobileExist() {
      return this.c_isMobileReadyAndMobileCodeCounterOk && false === this.isMobileExist;
    },

    c_mobileCodeBtnTxt() {
      if (this.c_isMobileCodeCounterOk) {
        return '获取短信验证码';
      } else {
        return this.mobileCodeCounter + 's后重新获取';
      }
    },

    c_isMobileCodeReady() {
      if ('' === this.mobileCode) {
        return false;
      }
      return true;
    },
  },

  methods: {
    ...mapActions('Mixins/Mobile', {
      ma_getRegionNo: 'getRegionNo',
      ma_checkExistMobile: 'checkExistMobile',
      ma_getMobileCode: 'getMobileCode',
      ma_getMobileCodeLogin: 'getMobileCodeLogin',
      ma_getMobileCodeLoginWithoutMobile: 'getMobileCodeLoginWithoutMobile',
      ma_getMobileCodeLoginUniqueGlobal: 'getMobileCodeLoginUniqueGlobal',
      ma_updateMobile: 'updateMobile',
    }),

    getRegionNo() {
      if (this.ms_regionNo.length === 0) {
        this.ma_getRegionNo();
      }
      //this.changeCaptcha();
    },

    async checkExistMobile() {
      if (this.shortMobile) {
        const res = await this.ma_checkExistMobile(this.c_mobile);
        this.isMobileExist = res.data.data;
      }
    },

    toggleRegionList() {
      this.isRegionShown = true;
    },

    setRegionNo(regionNo) {
      this.region = regionNo.countryNumber;
      this.regionCountry = regionNo.countryName;
      // console.log(this.ms_regionNo);
      $('.phone-reg .dropdown-toggle').dropdown('hide');
    },

    handleChangeMobile() {
      this.errMessageMobile = '';
      this.isMobileExist = '';
    },

    handleChangeMobileAndCheckExist() {
      this.handleChangeMobile();
      this.checkExistMobile();
    },

    handleMobileCodeChange() {
      this.errMessageMobileCode = '';
    },

    _getMobileCode_setItvl() {
      this.mobileCodeCounter -= 1;
      this.itvlMobileCode = setInterval(() => {
        this.mobileCodeCounter -= 1;
        if (0 === this.mobileCodeCounter) {
          clearInterval(this.itvlMobileCode);
          this.mobileCodeCounter = MOBILE_TIMER;
        }
      }, 1000);
    },

    async _getMobileCode(type) {
      if ('getMobileCode' === type || 'getMobileCodeLogin' === type) {
        if (!this.c_isMobileReady) {
          return;
        }
      }
      if (!this.c_isMobileCodeCounterOk) {
        return;
      }
      this._getMobileCode_setItvl();
      let res;
      if ('getMobileCode' === type) {
        res = await this.ma_getMobileCode(this.c_mobile);
      } else if ('getMobileCodeLogin' === type) {
        res = await this.ma_getMobileCodeLogin(this.c_mobile);
      } else if ('getMobileCodeLoginWithoutMobile' === type) {
        res = await this.ma_getMobileCodeLoginWithoutMobile();
      } else if ('getMobileCodeLoginUniqueGlobal' === type) {
        res = await this.ma_getMobileCodeLoginUniqueGlobal(this.c_mobile);
      }
      if (res.data.data) {
        //
      } else {
        this.errMessageMobileCode = res.data.message;
      }
    },

    getMobileCode(isDisabled) {
      if (isDisabled) {
        return false;
      }
      this._getMobileCode('getMobileCode');
    },

    getMobileCodeLogin(isDisabled) {
      if (isDisabled) {
        return false;
      }
      this._getMobileCode('getMobileCodeLogin');
    },

    getMobileCodeLoginWithoutMobile(isDisabled) {
      if (isDisabled) {
        return false;
      }
      this._getMobileCode('getMobileCodeLoginWithoutMobile');
    },

    getMobileCodeLoginUniqueGlobal(isDisabled) {
      if (isDisabled) {
        return false;
      }
      this._getMobileCode('getMobileCodeLoginUniqueGlobal');
    },

    async updateMobile() {
      if (!this.c_isMobileReady || !this.c_isMobileCodeReady) {
        return;
      }
      if (null !== this.params) {
        return;
      }
      this.params = this.ma_updateMobile({
        shortMobile: this.shortMobile,
        mobile: this.c_mobile,
        mobileCode: this.mobileCode,
      });
      const res = await this.params;
      if (res.data.data) {
        this.$refs.cancelMobile.click();
      } else {
        this.errMessageMobile = res.data.message;
      }
      this.params = null;
    },
  },

  created() { },

  mounted() {
    $('.phone-reg .dropdown-toggle').on('show.bs.dropdown', function () {
      this.isRegionShown = false;
    });
  },

  beforeDestroy() {
    clearInterval(this.itvlMobileCode);
  },
};

export default MobileMixin;
